<template>
  <v-text-field
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    @change="load();"
    @click:clear="reset();"
    @keyup="load();"
    :label="label"
    variant="outlined"
    density="compact"
    hide-details
    clearable
    class="subnav-header-field d-inline-block mx-1"
    v-bind="$attrs"
  ></v-text-field>
</template>

<script>
export default {
  name: 'BaseViewHeaderSearch',

  inheritAttrs: false,

  props: {
    modelValue: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Search',
    },
    search: {
      type: Function,
      default: () => {},
    },
  },

  emits: ['update:modelValue'],

  data () {
    return {
      previousValue: '',
    }
  },

  watch: {
    modelValue() {
      this.load();
    },
  },

  methods: {

    reset() {
      this.previousValue = '';
      this.$emit('update:modelValue', '');
      this.search();
    },

    load() {
      if (this.modelValue == this.previousValue) return;
      this.previousValue = this.modelValue;
      this.search();
    },

  },
};
</script>
